import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  CartesianGrid,
  Tooltip,
  Cell,
} from "recharts";
import {
  downloadLeadJourneyDropOutCustomerReason,
  getLeadJourneyDropOutCustomerReason,
} from "../ActionCreator";
import moment from "moment";
import { Pagination, Stack } from "@mui/material";
import Loader from "../../../../presentationals/Loader/Loader.component";

const StagePopup = ({
  open,
  stage,
  date,
  dropOutAnalysis,
  stageAnalysis,
  onClose,
  currentStage,
  nextStage,
  loader,
}) => {
  const [selectedReason, setSelectedReason] = useState(null);
  const [customerList, setCustomerList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalElement, setTotalElement] = useState();
  const [tableLoader, setTableLoader] = useState(false);

  // const handleViewCustomer = (reason) => {
  //   const sDate = moment(date.from).format("DD-MM-YYYY");
  //   const eDate = moment(date.to).format("DD-MM-YYYY");

  //   setSelectedReason(reason);

  //   getLeadJourneyDropOutCustomerReason(
  //     sDate,
  //     eDate,
  //     currentStage,
  //     nextStage,
  //     reason,
  //     page,
  //     10,
  //     (res) => {
  //       setCustomerList(res?.data?.customers || []);
  //       setTotalElement(res?.data?.totalCount);
  //     },
  //   );
  // };

  const fetchCustomerList = (reason, pageNo) => {
    const sDate = moment(date.from).format("DD-MM-YYYY");
    const eDate = moment(date.to).format("DD-MM-YYYY");
    setTableLoader(true);
    getLeadJourneyDropOutCustomerReason(
      sDate,
      eDate,
      currentStage,
      nextStage,
      reason,
      page,
      10,
      (res) => {
        setCustomerList(res?.data?.customers || []);
        setTotalElement(res?.data?.totalCount);
        setTableLoader(false);
      },
    );
  };

  const handleViewCustomer = (reason) => {
    setSelectedReason(reason);
    setPage(1);

    fetchCustomerList(reason, 1);
  };

  useEffect(() => {
    if (selectedReason) {
      fetchCustomerList(selectedReason, page);
    }
  }, [page]);

  const downloadDeopoutCustomerReason = () => {
    const sDate = moment(date.from).format("DD-MM-YYYY");
    const eDate = moment(date.to).format("DD-MM-YYYY");

    downloadLeadJourneyDropOutCustomerReason(
      sDate,
      eDate,
      currentStage,
      nextStage,
      selectedReason,
      (res) => {
        const blob = new Blob([res], { type: "text/csv" });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", "dropout_customer_reason.csv");

        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      },
    );
  };

  if (!open) return null;

  const summaryData = [
    {
      label: "Drop off %",
      value: `${stageAnalysis?.data?.dropOffPercent ?? 0}%`,
    },
    {
      label: "Total Dropouts",
      value: stageAnalysis?.data?.totalDropouts ?? 0,
    },
    {
      label: "Cost Impact",
      value: `₹${Number(stageAnalysis?.data?.costImpact ?? 0).toLocaleString(
        "en-IN",
      )}`,
    },
  ];

  const reasonsData =
    dropOutAnalysis?.data?.reasons?.map((item) => ({
      ...item,
      costImpact: Number(item.costImpact),
    })) || [];

  const totalCount = reasonsData?.reduce(
    (sum, item) => sum + Number(item.count || 0),
    0,
  );

  const totalImpact = reasonsData?.reduce(
    (sum, item) => sum + Number(item.costImpact || 0),
    0,
  );

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.35)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
      }}
    >
      {loader ? (
        <Loader />
      ) : (
        <div
          style={{
            // width: "800px",
            width: `calc(100vw - 300px)`,
            background: "#fff",
            borderRadius: "16px",
            padding: "30px",
            height: `calc(100vh - 100px)`,
            overflow: "scroll",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
              <h4>{stage?.label}</h4>

              {/* <span
                style={{
                  background: "#eee",
                  padding: "6px 12px",
                  borderRadius: "10px",
                }}
              >
                {stageAnalysis?.data?.leads} Leads
              </span> */}
            </div>

            <button
              onClick={() => {
                onClose();
                setCustomerList([]);
                setSelectedReason("");
              }}
              style={{
                border: "none",
                background: "#eee",
                borderRadius: "50%",
                width: "32px",
                height: "32px",
                cursor: "pointer",
              }}
            >
              ✕
            </button>
          </div>

          {/* Stats */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginBottom: "25px",
            }}
          >
            {/* {summaryData.map((item, i) => (
              <div
                key={i}
                style={{
                  flex: 1,
                  border: "1px solid #ffbcbc",
                  borderRadius: "14px",
                  padding: "20px",
                  background: "#fff6f6",
                }}
              >
                <p style={{ color: "#c33" }}>{item.label}</p>
                <h3 style={{ color: "#e53935" }}>{item.value}</h3>
              </div>
            ))} */}
              <div

                style={{
                  flex: 1,
                  border: "1px solid #ffbcbc",
                  borderRadius: "14px",
                  padding: "20px",
                  background: "#fff6f6",
                }}
              >
                <p style={{ color: "#c33" }}>Total Dropouts</p>
                <h3 style={{ color: "#e53935" }}>{dropOutAnalysis?.data?.totalDropouts ?? 0}</h3>
              </div>
              <div

                style={{
                  flex: 1,
                  border: "1px solid #ffbcbc",
                  borderRadius: "14px",
                  padding: "20px",
                  background: "#fff6f6",
                }}
              >
                <p style={{ color: "#c33" }}>Cost Impact</p>
                <h3 style={{ color: "#e53935" }}>{`₹${totalImpact?.toFixed(2) ?? 0}`}</h3>
              </div>
          </div>

          {/* Chart */}
          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: "16px",
              padding: "20px",
              marginBottom: "30px",
            }}
          >
            <h4 style={{ marginBottom: "20px" }}>
              Dropout Reason – Cost Impact
            </h4>

            <ResponsiveContainer width="100%" height={260}>
              <BarChart
                data={reasonsData}
                layout="vertical"
                margin={{ top: 10, right: 30, left: 60, bottom: 10 }}
              >
                <CartesianGrid strokeDasharray="3 3" horizontal={false} />

                <XAxis
                  type="number"
                  tickFormatter={(v) => `₹${v}`}
                  axisLine={false}
                  tickLine={false}
                />

                <YAxis
                  type="category"
                  dataKey="reason"
                  axisLine={false}
                  tickLine={false}
                  width={180}
                />

                <Tooltip formatter={(v) => `₹${v}`} />

                <Bar
                  dataKey="costImpact"
                  fill="#ef5350"
                  radius={[0, 6, 6, 0]}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>

          {/* Table */}
          <div style={{ borderRadius: "16px" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead style={{ background: "#f5f5f5" }}>
                <tr>
                  <th style={{ padding: "12px" }}>Reason</th>
                  <th style={{ textAlign: "center" }}>Count</th>
                  <th style={{ textAlign: "center" }}>Cost Impact</th>
                  <th style={{ textAlign: "center" }}>% of Total</th>
                  <th style={{ textAlign: "center" }}>Action</th>
                </tr>
              </thead>

              <tbody>
                {reasonsData?.map((r, i) => {
                  return (
                    <tr key={i} style={{ borderBottom: "1px solid #ddd" }}>
                      <td style={{ padding: "14px" }}>{r.reason}</td>
                      <td style={{ textAlign: "center" }}>{r.count}</td>
                      <td style={{ color: "#e53935", textAlign: "center" }}>
                        ₹{r.costImpact}
                      </td>
                      <td style={{ textAlign: "center" }}>{r.percent}%</td>
                      <td
                        style={{ textAlign: "center" }}
                        onClick={() => handleViewCustomer(r.reason)}
                      >
                        <span
                          style={{
                            color: "#1976d2",
                            cursor: "pointer",
                            fontWeight: 500,
                          }}
                        >
                          View Customer
                        </span>
                      </td>
                    </tr>
                  );
                })}

                <tr style={{ background: "#eef5f6" }}>
                  <td style={{ padding: "14px" }}>Total</td>
                  <td style={{ textAlign: "center" }}>{totalCount}</td>
                  <td
                    style={{ color: "#e53935", textAlign: "center" }}
                  >{`₹${totalImpact?.toFixed(2)}`}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>

          {tableLoader ? (
            <Loader />
          ) : (
            selectedReason && (
              <div style={{ marginTop: "40px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <h5 style={{ marginBottom: "8px", fontWeight: 600 }}>
                      Customer Details – {selectedReason}
                    </h5>

                    <p style={{ color: "#666", marginBottom: "20px" }}>
                      {customerList.length} customers | Total Cost Impact ₹
                      {customerList.reduce(
                        (a, b) => a + Number(b.costImpact || 0),
                        0,
                      )}
                    </p>
                  </div>

                  <div>
                    <button
                      onClick={downloadDeopoutCustomerReason}
                      className="btn btn-primary"
                      style={{
                        backgroundColor: "#0088ff",
                        border: "none",
                      }}
                    >
                      Export CSV
                    </button>
                  </div>
                </div>

                <div
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: "16px",
                  }}
                >
                  <div
                    style={{
                      overflow: "scroll",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead style={{ background: "#f3f3f3" }}>
                        <tr>
                          <th
                            style={{ padding: "14px 18px", textAlign: "left" }}
                          >
                            Name
                          </th>
                          <th
                            style={{ padding: "14px 18px", textAlign: "left" }}
                          >
                            Contact
                          </th>
                          <th
                            style={{ padding: "14px 18px", textAlign: "left" }}
                          >
                            Loan Amount
                          </th>
                          <th
                            style={{ padding: "14px 18px", textAlign: "left" }}
                          >
                            Cost
                          </th>
                          <th
                            style={{ padding: "14px 18px", textAlign: "left" }}
                          >
                            Stage
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {customerList?.length > 0 ? (
                          customerList?.map((c, i) => (
                            <tr key={i} style={{ borderTop: "1px solid #eee" }}>
                              <td
                                style={{
                                  padding: "16px 18px",
                                  fontWeight: 500,
                                }}
                              >
                                {c.name}
                              </td>

                              <td style={{ padding: "16px 18px" }}>
                                <div style={{ fontSize: "14px" }}>
                                  {c.mobileNumber}
                                </div>

                                <div
                                  style={{ fontSize: "12px", color: "#777" }}
                                >
                                  {c.emailId}
                                </div>
                              </td>

                              <td style={{ padding: "16px 18px" }}>
                                ₹{Number(c.loanAmount).toLocaleString()}
                              </td>

                              <td
                                style={{
                                  padding: "16px 18px",
                                  color: "#e53935",
                                  fontWeight: 500,
                                }}
                              >
                                ₹{Number(c.costImpact).toLocaleString()}
                              </td>

                              <td style={{ padding: "16px 18px" }}>
                                <span
                                  style={{
                                    border: "1px solid #ccc",
                                    padding: "4px 10px",
                                    borderRadius: "8px",
                                    fontSize: "11px",
                                    background: "#fafafa",
                                  }}
                                >
                                  {c.stage}
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="10"
                              style={{ textAlign: "center", padding: "20px" }}
                            >
                              No Data ..
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {totalElement > 10 && (
                    <Stack
                      direction="row"
                      justifyContent="end"
                      alignItems="center"
                      sx={{ mb: 2 }}
                    >
                      <Pagination
                        count={Math.ceil(totalElement / 10)}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                        // color="#43a4c7"
                        // shape="rounded"
                        sx={{
                          "& .MuiPaginationItem-root": {
                            color: "#43a4c7",
                            fontSize:
                              window.innerWidth >= 1800 ? "20px" : "14px",
                            minWidth:
                              window.innerWidth >= 1800 ? "40px" : "32px",
                            height: window.innerWidth >= 1800 ? "40px" : "32px",
                          },
                          "& .MuiPaginationItem-root.Mui-selected": {
                            backgroundColor: "#43a4c7",
                            color: "#fff",
                          },
                        }}
                      />
                    </Stack>
                  )}
                </div>
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default StagePopup;
